import {pick} from "~/lib/helpers";
import {Role} from "~/modules/users/lib/roles-utils";
import {filterObject} from "~/lib/helpers/objects";
import {AvailableRolesCollection} from "~/modules/notifications/lib/available-roles-collection";

export class Recipients {

  public rolesUUIDs: string[] = [];
  public clientsUUIDs: string[] = [];

  constructor(initialClientUUID?: string) {
    if (initialClientUUID) {
      this.clientsUUIDs.push(initialClientUUID);
    }
  }

  isValid(): boolean {
    return this.rolesUUIDs.length > 0 && this.clientsUUIDs.length > 0;
  }

  toggleRole(uuid: string) {
    this.rolesUUIDs = toggleInArray(this.rolesUUIDs, uuid);
  }

  // automatically deselect roles when client is deselected and it is the only one to propose those roles
  syncRoleSelection(clientUUID: string, availableRoles: AvailableRolesCollection) {
    if (availableRoles.getRolesOfClient(clientUUID)) {
      for (let role of availableRoles.getRolesOfClient(clientUUID)) {
        if (this.isRoleSelected(role.uuid) && !this.roleIsOnOtherClients(clientUUID, role, availableRoles)) {
          this.toggleRole(role.uuid);
        }
      }
    }
  }

  isRoleSelected(uuid: string) {
    return this.rolesUUIDs.includes(uuid);
  }

  toggleClient(uuid: string) {
    this.clientsUUIDs = toggleInArray(this.clientsUUIDs, uuid);
  }

  isClientSelected(uuid: string) {
    return this.clientsUUIDs.includes(uuid);
  }

  toJSON() {
    return {
      type: "roles",
      ...pick(this, ["rolesUUIDs", "clientsUUIDs"])
    };
  }

  private roleIsOnOtherClients(clientUUID: string, role: Role, availableRoles: AvailableRolesCollection) {
    let otherClients = filterObject(availableRoles.rolesByClients, key => key !== clientUUID && this.isClientSelected(key)) as Record<string, Role[]>;
    for (let roles of Object.values(otherClients)) {
      if (roles.some(item => item.uuid === role.uuid)) {
        return true;
      }
    }
    return false;
  }
}

function toggleInArray(array: string[], value: string) {

  if (array.includes(value)) {
    return array.filter(item => item !== value);
  }

  array.push(value);
  return array;
}